"use client"

import type React from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import type { DocumentClassifier } from "@/types"

interface AddClassificationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  editing: DocumentClassifier | null
  onSave: (classification: Partial<DocumentClassifier>) => void
  trigger: React.ReactNode
  className?: string
}

export function AddClassificationDialog({
  open,
  onOpenChange,
  editing,
  onSave,
  trigger,
  className,
}: AddClassificationDialogProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    const name = formData.get("name") as string
    const description = formData.get("description") as string
    const classification_prompt = formData.get("classification_prompt") as string
    const extraction_prompt = formData.get("extraction_prompt") as string


    onSave({
      name,
      description,
      classification_prompt,
      extraction_prompt,
      extraction_schema: editing?.extraction_schema || {},
      created_at: editing?.created_at || "",
      visualizer_json: editing?.visualizer_json,
      updated_at: "",
    })
  }

  return (
    <Dialog  open={open} onOpenChange={onOpenChange} >
      <DialogTrigger className={` ${className}`}  asChild>{trigger}</DialogTrigger>
      <DialogContent className={`max-w-2xl `}  >
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>{editing ? "Edit Classification" : "Add Classification"}</DialogTitle>
            <DialogDescription>
              {editing ? "Update classification details" : "Create a new document classification"}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="name">Classification Name</Label>
              <Input id="name" name="name" defaultValue={editing?.name} placeholder="Referral" required />
            </div>
            <div className="space-y-2">
              <Label htmlFor="description">Description</Label>
              <Textarea
                id="description"
                name="description"
                defaultValue={editing?.description}
                placeholder="Patient referral documents from other providers"
                rows={3}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="classification_prompt">Classification Prompt</Label>
              <Textarea
                id="classification_prompt"
                name="classification_prompt"
                defaultValue={editing?.classification_prompt}
                placeholder="Documents containing referral requests, consultation requests, or patient transfers..."
                rows={4}
              />
            </div>

          </div>
          <DialogFooter>
            <Button type="submit" onClick={()=>{}}>{editing ? "Update" : "Create"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}

